import React from 'react';
import ReactPlayer from 'react-player/lazy';
export var VideoPlayer = function VideoPlayer(_ref) {
  var url = _ref.url,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? true : _ref$controls,
    light = _ref.light,
    _ref$controlsList = _ref.controlsList,
    controlsList = _ref$controlsList === void 0 ? '' : _ref$controlsList,
    disablePictureInPicture = _ref.disablePictureInPicture,
    loop = _ref.loop,
    muted = _ref.muted,
    playing = _ref.playing,
    width = _ref.width,
    height = _ref.height,
    style = _ref.style,
    wrapper = _ref.wrapper,
    playIcon = _ref.playIcon,
    _ref$onEnded = _ref.onEnded,
    onEnded = _ref$onEnded === void 0 ? function () {} : _ref$onEnded,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError,
    _ref$onPause = _ref.onPause,
    onPause = _ref$onPause === void 0 ? function () {} : _ref$onPause,
    _ref$onBuffer = _ref.onBuffer,
    onBuffer = _ref$onBuffer === void 0 ? function () {} : _ref$onBuffer,
    _ref$onBufferEnd = _ref.onBufferEnd,
    onBufferEnd = _ref$onBufferEnd === void 0 ? function () {} : _ref$onBufferEnd,
    _ref$onPlay = _ref.onPlay,
    onPlay = _ref$onPlay === void 0 ? function () {} : _ref$onPlay,
    _ref$handleClickPrevi = _ref.handleClickPreview,
    handleClickPreview = _ref$handleClickPrevi === void 0 ? function () {} : _ref$handleClickPrevi,
    player = _ref.player,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var config = {
    file: {
      attributes: {
        controlsList: controlsList,
        disablePictureInPicture: disablePictureInPicture
      }
    }
  };
  return /*#__PURE__*/React.createElement(ReactPlayer, {
    ref: player,
    url: url,
    controls: controls,
    light: light,
    config: config,
    loop: loop,
    muted: muted,
    playing: playing,
    width: width,
    height: height,
    style: style,
    wrapper: wrapper,
    playIcon: playIcon,
    onEnded: onEnded,
    onError: onError,
    onPause: onPause,
    onBuffer: onBuffer,
    onBufferEnd: onBufferEnd,
    onPlay: onPlay,
    className: className,
    onClickPreview: handleClickPreview
  });
};
export default VideoPlayer;